<template>
  <div id="app-layout" class="flex flex-col min-h-screen">
    <TheHeader />

    <!-- 主内容区域 -->
    <main class="app-page-surface flex-grow app-main">
      <router-view />
    </main>

      <footer class="app-page-surface py-4 text-center text-gray-500 text-sm">
      <p>
        <span>Copyright &copy; 2025 PhotoScope </span>
        <span>
          |
          <router-link :to="`/${$i18n.locale}/terms`">{{ t('landing.footer.company.terms') }}</router-link> |
          <router-link :to="`/${$i18n.locale}/privacy`">{{ t('landing.footer.company.privacy') }}</router-link>
        </span>
      </p>
    </footer>
  </div>
</template>

<script setup>
import TheHeader from '@/components/TheHeader.vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script> 

<style scoped>
.app-page-surface {
  background-color: var(--app-page-bg);
}

/* 阶段0 安全区适配：顶栏高度叠加 safe-area-top，避免刘海机型偏移；
   底部叠加 safe-area-bottom，避免内容/吸底元素被 home indicator 遮挡。
   env() 带 0px 兜底，不支持的浏览器忽略该计算、沿用默认内边距。 */
.app-main {
  padding: 0.75rem max(0.75rem, env(safe-area-inset-right, 0px))
    max(1rem, env(safe-area-inset-bottom, 0px))
    max(0.75rem, env(safe-area-inset-left, 0px));
  padding-top: calc(4rem + env(safe-area-inset-top, 0px));
}
</style>
